import { ClassFormatEnum, ClassTypeEnum } from '../../../../../types/enums';
import { ClassTeam } from '../ClassesTag/ClassesTag';

export const shuffleTeams = (teams: ClassTeam[] = []): ClassTeam[] => {
  const maxNumber = teams.length;

  const newSeedArray = new Array(maxNumber)
    .fill(null)
    .map((i, index) => index + 1)
    .filter((v) => !teams.find(({ seed, shuffled }) => seed === v && !shuffled));

  return JSON.parse(JSON.stringify(teams)).map((i: ClassTeam) => {
    if (!i.seed || i.shuffled) {
      const indexFromNewSeedArray = Math.floor(Math.random() * newSeedArray.length);
      i.seed = newSeedArray[indexFromNewSeedArray];
      newSeedArray.splice(indexFromNewSeedArray, 1);
      i.shuffled = true;
    }
    return i;
  });
};

export const seedTeamsByDuprRating = (
  teams: ClassTeam[] = [],
  type: ClassTypeEnum,
  format: ClassFormatEnum
): ClassTeam[] => {
  const teamsWithDuprRating = teams.map((t) => {
    const totalRatedPlayers = t.users.reduce(
      (acc, user) => {
        if (
          (type === ClassTypeEnum.DOUBLES ||
            format === ClassFormatEnum.BOX_LEAGUE ||
            format === ClassFormatEnum.BOX_LEAGUE_ELIM) &&
          user.duprRatingDoubles
        ) {
          acc.totalRating += parseFloat(user.duprRatingDoubles);
          acc.totalRatedUsers++;
        } else if (
          type === ClassTypeEnum.SINGLES &&
          format !== ClassFormatEnum.BOX_LEAGUE &&
          format !== ClassFormatEnum.BOX_LEAGUE_ELIM &&
          user.duprRatingSingles
        ) {
          acc.totalRating += parseFloat(user.duprRatingSingles);
          acc.totalRatedUsers++;
        }
        return acc;
      },
      { totalRating: 0, totalRatedUsers: 0 }
    );

    const totalDuprRating =
      totalRatedPlayers.totalRatedUsers > 0 ? totalRatedPlayers.totalRating : 0;

    return {
      ...t,
      totalDuprRating,
    };
  });

  return teamsWithDuprRating
    .sort((a, b) => b.totalDuprRating - a.totalDuprRating)
    .map(({ totalDuprRating, ...t }, index) => ({
      ...t,
      seed: index + 1,
      shuffled: true,
    }));
};
